import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const createDenominationReport = ({ formToken, reportData }) => {
  return axios.post(`/denominations/${formToken}/report`, reportData);
};

export const useCreateDenominationReport = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["denomination-reports"]);
      setNotification({
        type: "success",
        message: "Denomination report created successfully!"
      });
    },
    ...config,
    mutationFn: createDenominationReport
  });
};
